import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";
import { IconProps } from "@/common/contracts/icon.contracts";

/* Sprite-backed: PDP favourite buttons; the path lives in `IconSprite`. */
const Heart = ({ className }: IconProps) => {
  return (
    <SpriteIcon
      symbol={SPRITE_SYMBOLS.lineHeart}
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    />
  );
};

export default Heart;
